.root {
    width: 100%;
    position: relative;
    overflow-anchor: none;
}

.stickyTop {
    position: sticky;
    top: 0;
    z-index: 10;
    width: 100%;
    background-color: var(--mantine-color-body);
    display: flex;
    flex-direction: column;
    gap: var(--mantine-spacing-md);
    overflow-anchor: none;
    transition: gap 0.25s ease;
}

.stickyTop[data-collapsed="true"] {
    gap: var(--mantine-spacing-2xs);
}

.stickyToggle {
    position: absolute;
    top: var(--mantine-spacing-sm);
    left: var(--mantine-spacing-sm);
    z-index: 1;
}

.layout {
    width: 100%;
    max-width: var(--app-max-width);
    margin: 0 auto;
    margin-top: var(--mantine-spacing-xs);
    padding-inline: var(--mantine-spacing-xl);
}

.sidebar {
    flex: 0 0 250px;
    padding-right: var(--mantine-spacing-md);
    position: sticky;
    top: var(--top-area-height, 0px);
    align-self: flex-start;
    max-height: calc(100vh - var(--top-area-height, 0px));
    overflow-y: auto;
}

.contentArea {
    flex: 1;
    min-width: 0;
}

.scrollCompensation {
    flex-shrink: 0;
    width: 100%;
    height: var(--top-area-collapse, 0px);
}

.portalsList {
    /* No longer load-bearing for the scrollspy (the tail override in
       DashboardLayout elects the last section when it's fully visible). Just a
       little breathing room before the footer. */
    padding-bottom: var(--mantine-spacing-xl);
}

.groupingSection {
    scroll-margin-top: calc(var(--top-area-height, 0px) + var(--mantine-spacing-md));
    padding-top: var(--mantine-spacing-xl);
}

.groupingSection:first-of-type {
    padding-top: var(--mantine-spacing-md);
}

.groupingHeading {
    font-size: var(--mantine-font-size-xl);
    font-weight: 500;
    color: var(--dib-ink);
    margin: 0 0 var(--mantine-spacing-md) 0;
    letter-spacing: -0.02em;
}

.searchSection {
    width: 100%;
    max-width: var(--app-max-width);
    margin: 0 auto;
    margin-top: 128px;
    margin-bottom: var(--mantine-spacing-xs);
    padding-inline: var(--mantine-spacing-xl);
    transition:
        margin-top 0.25s ease,
        margin-bottom 0.25s ease,
        padding-left 0.25s ease;
}

.stickyTop[data-collapsed="true"] .searchSection {
    margin-top: 24px;
    margin-bottom: 5px;
}

.tabRow {
    display: flex;
    flex-direction: column;
    gap: var(--mantine-spacing-sm);
    width: 100%;
    max-width: var(--app-max-width);
    margin: 0 auto;
    padding-inline: var(--mantine-spacing-xl);
    padding-top: var(--mantine-spacing-xl);
    transition: padding-top 0.25s ease;
}

.stickyTop[data-collapsed="true"] .tabRow {
    padding-top: var(--mantine-spacing-md);
}

.tabs {
    display: flex;
    align-items: flex-end;
    gap: var(--mantine-spacing-lg);
    border-bottom: 1px solid var(--dib-surface);
    padding-bottom: 0;
}

.tab {
    font-size: 16px;
    font-weight: 400;
    color: #696969;
    padding-bottom: var(--mantine-spacing-xs);
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;
    text-decoration: none;
    background: none;
    border-top: none;
    border-left: none;
    border-right: none;
    cursor: pointer;
    transition:
        color 0.15s ease,
        border-color 0.15s ease;

    &:hover {
        color: var(--dib-ink);
    }

    &[data-active="true"] {
        color: var(--dib-ink);
        border-bottom: 2px solid var(--dib-ink);
    }
}

.mobileSelect {
    width: 100%;
}

.mobileSelectInput {
    min-height: 42px;
    border-color: var(--dib-brand-grey-rgb-1);
    color: var(--dib-text-dark-blue-rgb);
    font-weight: 400;
}

.mobileSelectDropdown {
    border-color: var(--dib-brand-grey-rgb-1);
}

.mobileSelectOption {
    font-size: var(--mantine-font-size-sm);
}

@media (max-width: 48em) {
    .searchSection {
        max-width: none;
        padding-inline: var(--mantine-spacing-md);
        margin-top: var(--mantine-spacing-lg);
    }

    /* No hero area on mobile — keep input position fixed regardless of scroll state. */
    .stickyTop[data-collapsed="true"] .searchSection {
        margin-top: var(--mantine-spacing-lg);
        margin-bottom: var(--mantine-spacing-xs);
    }

    .layout {
        max-width: none;
        padding-inline: var(--mantine-spacing-md);
    }

    .contentArea {
        width: 100%;
    }

    .tabRow {
        padding-inline: var(--mantine-spacing-md);
    }

    .tab {
        font-size: var(--mantine-font-size-sm);
    }

}

/* Mobile: toggle always sits on top of the input — indent regardless of scroll. */
@media (max-width: 48em) {
    .stickyTop[data-has-toggle="true"] .searchSection {
        padding-left: calc(48px + var(--mantine-spacing-sm));
    }
}

/* Desktop up to app-max-width: searchSection is no longer centered, only overlaps after scroll. */
@media (min-width: 48.0625em) and (max-width: 87.5em) {
    .stickyTop[data-has-toggle="true"][data-collapsed="true"] .searchSection {
        padding-left: calc(48px + var(--mantine-spacing-sm));
    }
}

/* Staggered entrance once data loads. animation-delay is set inline per
   element index to produce the top-to-bottom domino. */
@keyframes navItemIn {
    from {
        opacity: 0;
        transform: translateX(-9px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes contentIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.navItemAnimate {
    animation: navItemIn 0.35s var(--transition-ease-snappy, ease) both;
}

.contentAnimate {
    animation: contentIn 0.4s var(--transition-ease-snappy, ease) both;
}

@media (prefers-reduced-motion: reduce) {
    .navItemAnimate,
    .contentAnimate {
        animation: none;
    }
}
